'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ConfirmWindow = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _ConfirmButton = require('../ui/ConfirmButton');

var ConfirmWindow = exports.ConfirmWindow = undefined;

exports.ConfirmWindow = ConfirmWindow = function ConfirmWindow(refs, title, msg, btnText, fn, applyConfig) {
    var cancelFn = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : Function.prototype;
    var closeOnAccept = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;

    applyConfig = applyConfig || {};

    var i18n = refs.i18nManager.get();

    var confirmButtonText = btnText || 'OK';
    var cancelButtonText = i18n.cancel || 'Cancel';

    var defaults = {
        bodyStyle: 'background:#fff; border:0 none'
    };

    var closeFn = function closeFn() {
        return window.destroy();
    };

    var confirmFn = function confirmFn() {
        if (closeOnAccept) {
            closeFn();
            setTimeout(fn, 0);
        } else {
            fn();
        }
    };

    var confirmButton = new _ConfirmButton.ConfirmButton(refs, { text: confirmButtonText, fn: confirmFn, closeFn: closeFn });
    var cancelButton = new _ConfirmButton.ConfirmButton(refs, { type: 'close', text: cancelButtonText, fn: cancelFn, closeFn: closeFn });

    var window = Ext.create('Ext.window.Window', _extends({
        bodyStyle: 'background:#fff; padding:30px 60px 26px 42px',
        defaults: defaults,
        modal: true,
        preventHeader: true,
        resizable: false,
        closeable: false,
        items: [{
            html: title,
            bodyStyle: 'padding:0; border:0 none; font-size:16px',
            style: 'margin-bottom:20px'
        }, {
            html: msg,
            bodyStyle: 'padding:0; border:0 none; font-size:13px',
            style: 'margin-bottom:16px'
        }, {
            layout: 'hbox',
            defaults: defaults,
            items: [confirmButton, {
                width: 10
            }, cancelButton]
        }],
        listeners: {
            afterrender: function afterrender() {
                this.setPosition(this.getPosition()[0], this.getPosition()[1] / 2);
            },
            show: function show() {
                confirmButton.focus(false, 50);
            }
        }
    }, applyConfig));

    return window;
};
//# sourceMappingURL=ConfirmWindow.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/ui/ConfirmWindow.js
 ** module id = 159
 ** module chunks = 0 1
 **/